"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    function Map() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Map.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_projection":
                return utils_1.parseFunc(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    Map.prototype.defaultOptions = function () {
        return {
            _projection: d3.geoMercator(),
        };
    };
    Map.prototype.init = function () {
        var _this = this;
        this._toolTip = __1.tooltip.create("areatip");
        this._groups = this.appendGroupT(_1.Component).data([]).options({});
        this._paths = this._groups.appendT(element_1.Path).options({
            d: function (d) { return _this._pathGenerator(d); },
            stroke: "white",
            "stroke-opacity": "0.2",
            _$postAppend: function () {
                _this._toolTip.attachTo(_this._paths.dom)
                    .renderHTML(function (d) {
                    return d.properties.name;
                });
            },
            _$mouseEnter: function (_, i, g) {
                g[i].style.strokeOpacity = "1";
            },
            _$mouseLeave: function (_, i, g) {
                g[i].style.strokeOpacity = "0.2";
            },
        });
        this._labels = this.appendGroupT(element_1.Text).data([]).options({
            _text: function (d) { return d.properties.name; },
            fill: "white",
            _x: function (d) { return _this._pathGenerator.centroid(d)[0]; },
            _y: function (d) { return _this._pathGenerator.centroid(d)[1]; },
            _anchor: 4 /* Middle */ | 32 /* Center */,
        });
    };
    Map.prototype.prepare = function () {
        var projection = this.getOption("_projection")
            .fitSize([this._getGeometry("_width", true), this._getGeometry("_height", false)], this.datum);
        this._pathGenerator = d3.geoPath().projection(projection);
        this._groups.data(this.datum.features);
        this._labels.data(this.datum.features);
        this.setupProxy({
            area: "_paths",
            label: "_labels",
        });
    };
    return Map;
}(_1.Component));
exports.Map = Map;
//# sourceMappingURL=map.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/map.js
// module id = 1165
// module chunks = 0 1